import { render } from "./findingsInfo.vue?vue&type=template&id=33883eca&scoped=true&ts=true"
import script from "./findingsInfo.vue?vue&type=script&lang=ts"
export * from "./findingsInfo.vue?vue&type=script&lang=ts"

import "./findingsInfo.vue?vue&type=style&index=0&id=33883eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33883eca"]])

export default __exports__